import React, { useState } from "react";
import { LiveAuctionCarDetail } from "@common/pages/Dashboard/components/LiveAuction/LiveAuctionCarDetaill";
import LiveAuctionCarsList from "../components/LiveAuction/LiveAuctionCarsList";
import { useLocation, useNavigate } from "react-router-dom";
import { routes } from "../../../utils/constants/routes";
import { useLogPageVisitMutation } from "@common/toolkit/appConfiguration/appConfigurationApi.js";

const LiveAuctionCars = () => {

  // useNavigate...
  const navigate = useNavigate();
  // useNavigate...

  // useLocation...
  const location = useLocation();
  // useLocation...

  const Vehicle_Id = location?.pathname?.split?.(`${routes.liveAuction}/`)?.[1];

  // useState variables start...
  const [detailView, setDetailView] = useState(false);
  const [selectedCar, setSelectedCar] = React.useState(null);
  // useState variables end...

  const [logPageVisitApiHandler, logPageVisitApiData] = useLogPageVisitMutation();

  React.useEffect(() => {
    (async () => {
      await logPageVisitApiHandler({
        payload: {
          page_id: 2
        }
      });
    })();
  }, []);

  if (Vehicle_Id) {
    return <LiveAuctionCarDetail 
      selectedCar={selectedCar}
      setSelectedCar={setSelectedCar}
    />;
  }
  return <LiveAuctionCarsList 
    selectedCar={selectedCar}
    setSelectedCar={setSelectedCar}
    onCarClick={(car) => {
      setSelectedCar(car);
      setDetailView(true);
      navigate(`${routes.dashboardNavigation}${routes.liveAuction}/${car?.Vehicle_Id}`);
    }}
  />;
};

export default LiveAuctionCars;
